/**
 * Google Analytics 4 (gtag.js). Loads only when VITE_GA_MEASUREMENT_ID is set
 * and VITE_ENABLE_ANALYTICS is not "false".
 *
 * @see https://developers.google.com/analytics/devguides/collection/ga4
 */

const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID
const ENABLED = import.meta.env.VITE_ENABLE_ANALYTICS !== 'false'

/**
 * Call once from main.jsx after env is available.
 */
export function initAnalytics() {
  if (!MEASUREMENT_ID || typeof MEASUREMENT_ID !== 'string' || !MEASUREMENT_ID.startsWith('G-')) {
    return
  }
  if (!ENABLED) return
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', MEASUREMENT_ID, { send_page_view: false })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`
  document.head.appendChild(script)
}

/**
 * SPA route changes — call from a component under BrowserRouter.
 * @param {string} path e.g. /dashboard?tab=1
 */
export function pageView(path) {
  if (!MEASUREMENT_ID || !ENABLED) return
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('config', MEASUREMENT_ID, { page_path: path })
}

/**
 * Custom event (optional).
 * @param {string} name
 * @param {Record<string, unknown>} [params]
 */
export function trackEvent(name, params) {
  if (!MEASUREMENT_ID || !ENABLED) return
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('event', name, params ?? {})
}
